import React, { useState } from 'react';
import clx from "classnames";
import { FiMoreVertical, FiPlus, FiSmile } from 'react-icons/fi';
import { EmojiPicker } from '../chat/messsenger/content/emojipicker';

export const Action = ({me}) =>{

    const [status, setStatus] = useState(false);
    return (
      <React.Fragment>
                          
              <div className={clx(
                  me ? '-left-14 top-2 flex-row-reverse' : '-right-14 top-2',
                `hidden group-hover:flex absolute z-50 flex items-center gap-2 text-gray-400`)}>
                
                  <div className="relative">
                      <div onClick={()=>setStatus(!status)} >
                          <div className="">
                              <FiMoreVertical size={23} className="cursor-pointer" />
                          </div>
                          <div
                          className={clx(
                            status == true ? 'block' :'hidden',
                            `dropdown absolute right-0 top-6 dark:bg-zinc-800 dark:border-zinc-700
                            z-10 divide-y border bg-white rounded-lg w-32`
                          )} 
                          >
                              <ul className="py-2 text-sm text-gray-200">
                              <li>
                                  <a href="#" className="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-700 px-4 py-2 flex gap-1 items-center"> <i data-feather="check" className="h-4 text-zinc-600 dark:text-zinc-300"></i> <p>Mark</p> </a>
                              </li>
                              <li>
                                  <a href="#" className="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-700 px-4 py-2 flex gap-1 items-center"> <i data-feather="repeat" className="h-4 text-zinc-600 dark:text-zinc-300"></i> <p>Forward</p> </a>
                              </li>
                              <li>
                                  <a href="#" className="block text-zinc-500 hover:bg-zinc-200 dark:text-zinc-300 dark:hover:bg-zinc-700 px-4 py-2 flex gap-1 items-center"> <i data-feather="trash-2" className="h-4 text-zinc-600 dark:text-zinc-300"></i>  <p>Delete</p> </a>
                              </li>                        
                              </ul>
                          </div>
                          
                          </div>
  
                  </div>
                    <ActionEmoji />
                  
                  {/** 
  
                  */}
                  
              </div>
  
      </React.Fragment>
    )
}

export const ActionEmoji = () =>{
    const [status, setStatus] = useState(false);
    return (
      <React.Fragment>
         <div className="relative group"  >
    
    
                          <div onClick={()=>setStatus(!status)} > <FiSmile size={23} className="cursor-pointer" /> </div>
                      
                          {status && (
                            <div className="absolute top-8 right-0">
                        
  
                            <div className="items-center absolute right-0 -top-5 bg-white dark:bg-zinc-800 p-1 cursor-pointer rounded-full shadow-md border border-gray-300 dark:border-zinc-600 z-50 flex gal-1 text-xl">
                                <div className="hover:scale-125">👍</div>
                                <div className="hover:scale-125">😍</div>
                                <div className="hover:scale-125">😂</div>
                                <div className="hover:scale-125">😲</div>
                                <div className="hover:scale-125">😞</div>
                                <div className="hover:scale-125">😡</div>
                                <div className="hover:scale-125">👎</div>
                           
                                
  
                              <EmojiPicker
                              direction='right-0 top-8'
                                emoji={<div  className="bg-gray-200 dark:bg-zinc-400 rounded-md mr-1 h-6 w-6 flex items-center justify-center"> <FiPlus size={23} className="dark:text-gray-600 text-gray-500 h-5" /> </div>}
                              />
  
                        </div>
  
                        
                        </div>
                          )}
                      </div>
      </React.Fragment>
    )
}